module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-241.ef0f0f9c.svg";